import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractFetchAdaptor } from '../../../common/fetch/abstract-fetch.adaptor';
import { NavController } from '@ionic/angular';

export interface ReferralLoginForm {
  token: string;
  login_method: string;
}
interface ReferralLoginResponse {}

@Injectable()
export class TncRejectAdaptor extends AbstractFetchAdaptor<object, unknown> {
  override name = 'tncReject';

  private http = inject(HttpClient);
  private navCtrl = inject(NavController);

  // Ensure onRequest returns an Observable
  override onRequest({ token, login_method }: ReferralLoginForm): Observable<ReferralLoginResponse> {
    return this.http.post(`/referrals/${token}/reject`, null, { params: { login_method } });
  }

  // This will be called by the component after the observable emits
  override onSuccess(_data: any) {
    this.navCtrl.navigateRoot('/invitation-declined');
  }
}
